export const FILTER_STATUSES = 'statuses';
export const FILTER_PARTNER_COMPANIES = 'partnerCompanies';
export const FILTER_CUSTOMER_COMPANIES = 'customerCompanies';
export const FILTER_NETWORKS = 'networks';
export const FILTER_INVOICE_LEVELS = 'invoiceLevels';
export const FILTER_CURRENCIES = 'currencies';
export const FILTER_EXPENSE_TYPES = 'expenseTypes';
export const FILTER_OWNERS = 'owners';
export const FILTER_CREATORS = 'creators';

export const FILTERS_DEPENDENCIES = {
  [FILTER_OWNERS]: [FILTER_PARTNER_COMPANIES],
  [FILTER_CREATORS]: [FILTER_PARTNER_COMPANIES],
};

export const COLUMN_ID = 'id';
export const COLUMN_NAME = 'name';
export const COLUMN_STATUS = 'status';
export const COLUMN_CUSTOMER_COMPANY = 'customerCompany';
export const COLUMN_PARTNER_COMPANY = 'partnerCompany';
export const COLUMN_NETWORK = 'network';
export const COLUMN_DPA_STATUS = 'hasValidDpa';
export const COLUMN_INVOICE_LEVEL = 'invoiceLevel';
export const COLUMN_CURRENCY = 'currency';
export const COLUMN_EXPENSE_TYPES = 'expenseTypes';
export const COLUMN_OWNER = 'owner';
export const COLUMN_CREATED_BY = 'createdBy';
export const COLUMN_CREATED_DATE = 'createdDate';
export const COLUMN_UPDATED_DATE = 'lastUpdatedDate';

export const ACTION_ACTIVATE = 'Activate';
export const ACTION_DEACTIVATE = 'Deactivate';
export const ACTION_DELETE = 'Delete';
export const ACTION_EDIT = 'Edit';
export const ACTION_MOVE_TO_TEST = 'Move to Test';

export const STATUS_DRAFT = 0;
export const STATUS_ACTIVE = 1;
export const STATUS_ARCHIVED = 2;
export const STATUS_IN_TEST = 3;
